import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import * as SolicitudViaticoService from '../../axios_services/viaticosolicitud.service';

const ModalSolicitudViatico = ({ isOpen, onClose, onRefresh, currentUserId, solicitudToEdit }) => {
    const [asunto, setAsunto] = useState('');
    const [detalle, setDetalle] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            if (solicitudToEdit) {
                setAsunto(solicitudToEdit.asunto || '');
                setDetalle(solicitudToEdit.detalle_solicitud || '');
            } else {
                setAsunto('');
                setDetalle('');
            }
        }
    }, [isOpen, solicitudToEdit]);

    const handleSave = async () => {
        if (!asunto.trim() || !detalle.trim()) {
            alert('El asunto y el detalle de la solicitud son requeridos.');
            return;
        }

        setLoading(true);
        try {
            if (solicitudToEdit) {
                await SolicitudViaticoService.updateSolicitud({
                    solicitud_id: solicitudToEdit.solicitud_id,
                    asunto: asunto,
                    detalle_solicitud: detalle
                });
            } else {
                await SolicitudViaticoService.insertSolicitud({
                    usuario_id: currentUserId,
                    asunto: asunto,
                    detalle_solicitud: detalle
                });
            }
            onRefresh();
            onClose();
        } catch (error) {
            console.error(error);
            alert(error.response?.data?.error || 'Error al guardar la solicitud');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{solicitudToEdit ? 'EDITAR SOLICITUD DE VIÁTICOS' : 'NUEVA SOLICITUD DE VIÁTICOS'}</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={e => e.preventDefault()}>
                        <FormGroup style={{ gridColumn: '1 / -1' }}>
                            <Label>Asunto: *</Label>
                            <Input
                                type="text"
                                value={asunto}
                                onChange={(e) => setAsunto(e.target.value)}
                                placeholder="Escriba el asunto..."
                            />
                        </FormGroup>
                        <FormGroup style={{ gridColumn: '1 / -1' }}>
                            <Label>Detalle de Solicitud: *</Label>
                            <Input
                                type="textarea"
                                rows="4"
                                value={detalle}
                                onChange={(e) => setDetalle(e.target.value)}
                                placeholder="Escriba el detalle de su solicitud..."
                            />
                        </FormGroup>
                        <FormGroup style={{ marginTop: '18px', gridColumn: '1 / -1' }}>
                            <div className="button-container">
                                <Button
                                    className="button-custom"
                                    onClick={handleSave}
                                    disabled={loading}
                                >
                                    {loading ? 'GUARDANDO...' : 'GUARDAR'}
                                </Button>
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalSolicitudViatico;
